import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import delayedUnmount from 'Components/Helpers/delayedUnmount';
import './ModalWrap.scss';
import bemClass from '@upsales/components/Utils/bemClass';
import { makeCancelable } from 'App/babel/helpers/promise';

class ModalWrap extends React.Component {
	constructor(props) {
		super(props);
		this.modalRoot = document.getElementById('react-root');
		this.el = document.createElement('div');
		this.state = { mounted: false };
	}

	componentDidMount() {
		this.modalRoot.appendChild(this.el);

		document.getElementsByTagName('body')[0].style.overflow = 'hidden';

		this._mountedPromise = makeCancelable(
			new Promise(r => {
				setTimeout(() => {
					this.setState({ mounted: true });
					r();
				}, 0);
			})
		);
	}

	componentWillUnmount() {
		this._mountedPromise.cancel();
		this.modalRoot.removeChild(this.el);

		document.getElementsByTagName('body')[0].style.overflow = null;
	}

	render() {
		const { isMounted, className, onClose, children, fullscreen } = this.props;
		const classes = new bemClass('ModalWrap', className).mod({ open: isMounted && this.state.mounted, fullscreen });
		return ReactDOM.createPortal(
			<div className={classes.b()} ref={r => (this._ref = r)}>
				<div className={classes.elem('curtain').b()} onClick={onClose} />
				<div className={classes.elem('content').b()}>{children}</div>
			</div>,
			this.el
		);
	}
}

ModalWrap.propTypes = {
	children: PropTypes.any,
	onClose: PropTypes.func,
	className: PropTypes.string,
	fullscreen: PropTypes.bool,
	isMounted: PropTypes.bool.isRequired
};

ModalWrap.defaultProps = {
	isMounted: true
};

export default delayedUnmount(ModalWrap);
